import axiosInstance from "../../apiAxios/axiosInstance";

// Category List
export const UnitList = (payload) => {
  return axiosInstance.post("/vendor/unit-list",payload);
};
export const ActiveUnitList = async(payload) => {
   const resposne=await axiosInstance.post("/vendor/active-unit-list",payload);
   return resposne.data
};
// Create
export const AddUnit = (payload) => {
  return axiosInstance.post("/admin/unit-store", payload);
};

// Show
export const VirwUnit = (payload) => {
  return axiosInstance.post("/admin/unit-show", payload);
};

// Update
export const UpdateUnit = (payload) => {
  return axiosInstance.post("/admin/unit-update", payload);
};

// Delete
export const DeleteUnit = async(payload) => {
 const response= await axiosInstance.post("/admin/unit-delete", payload);
 return response.data
};

// Status Change
export const UnitChangeStatus = (payload) => {
  return axiosInstance.post("/admin/unit-status-update", payload);
};